<style lang="scss">
.discover-page {
    font-size: 1rem;
    .page-title {
        padding-top: 30px;
    }
    .m-a-0{
        color: #ff5b94;
        font-family: Poppins;
        font-size: 30px;
        font-weight: 600;
        text-transform: uppercase;
    }

    .top-section{
        padding-bottom : 0px !important;
        padding-top : 0px !important;
    }
    .item {
        .item-info {
            .item-title {
                font-size: 1em;
            }
            .item-genre {
                font-size: 0.8em;
            }
        }
    }
    .primary-featured {

        .owl-theme {

            .owl-nav {
                margin-top: 0;

                .owl-prev, .owl-next {
                    position: absolute;
                    top: 50%;
                    width: 40px;
                    height: 30px;
                    margin-top: -15px;
                    display: inline-block;
                    text-align: center;
                    font-size: 18px;
                    background: transparent;
                    color: var(--highlight-color);
                    border: 0px !important;
                    &:after {
                        content: " ";
                        display: block;
                        position: absolute;
                        width: 30px;
                        height: 30px;
                        border-radius: 50%;
                        background: white;
                        opacity: .7;
                        top: 0;
                        z-index: 0;
                        box-shadow: 1px 1px 6px rgba(0, 0, 0, .4);
                    }
                    svg {
                        position: relative;
                        z-index: 1;
                    }
                }
                .owl-prev {
                    left: 3px;
                    &:after {
                        left: 6px;
                    }
                }
                .owl-next {
                    right: 3px;
                    &:after {
                        right: 6px;
                    }
                }
            }
            .owl-dots{
                .owl-dot {
                    border: 0;
                    background: transparent;
                    padding: 0;
                }
            }
        }
    }
    .secondary-featured {
        padding: 0 !important;
        font-size: 1em;

        .beat-container {
            .item {
                margin-bottom: 16px !important;
            }
     }
    }
    .trending {
        font-size: 1em;
    }
    .latest {
        font-size: 0.875em;
    }
    .chart {
        font-size: 1em;
    }

    .fixed {
        position: fixed;
        top: 0;
    }
}

@media (max-width: 1000px) {
    .discover-page {
        font-size: 0.875rem;
    }
}

@media (max-width: 768px) {
    .discover-page {
        .secondary-featured {
            .beat-container {
                .item-info {
                    .item-title {
                        font-size: 15px !important;
                    }
                    .genre {
                        font-size: 13px;
                    }
                }
            }
        }
    }
}

@media (max-width: 545px) {
    .discover-page {
        .primary-featured, .secondary-featured {
            //width: 100%;
        }
    }
}
</style>

<template>
    <div class="discover-page">
        <search-bar v-if="config.defaultBeatsPage"></search-bar>
        <div v-if="page" class="page-content">

            <div v-if="userHasBeats">
                <div v-if="page.featured.primary.show || page.featured.secondary.show" class="padding p-b-0 top-section">
                    <div class="page-title m-b">
                        <h1 class="inline m-a-0" :style="$highlightColor">Discover</h1>
                    </div>
                    <div class="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-2 sm:tw-gap-4">
                      <div class="primary-featured" v-if="page.featured.primary.show">
                        <PrimaryBeats :pageId="currentPageId"></PrimaryBeats>
                      </div>
                      <SecondaryBeats v-if="page.featured.secondary.show" :pageId="currentPageId"></SecondaryBeats>
                    </div>
                </div>
                <div class="row-col">
                    <div class="main-divider">
                        <div class="padding top-section">
                            <Latest v-if="page.new.show" :pageId="currentPageId" :display="display"></Latest>
                            <Trending v-if="page.trending.show" :pageId="currentPageId"></Trending>
                            <Soundkits v-if="page.soundkits.show" :pageId="currentPageId"></Soundkits>
                            <Songs v-if="page.songs.show" :pageId="currentPageId"></Songs>
                            <BeatTapes v-if="page.beattapes.show" :pageId="currentPageId"></BeatTapes>
                            <Services v-if="page.services.show" :pageId="currentPageId"></Services>
                            <Licenses v-if="page.licenses.show" :highlight="config.license"></Licenses>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="col-md-8 col-md-offset-2 text-center" style="margin-top:100px;">
                <div v-if = "loggedInUser">
                    <div v-if="user.id === loggedInUser.id">
                        Looks like you don't have any beats, visit your <a :href="appUrl" :style="$highlightColor" target="_blank">dashboard</a> to add new ones.
                    </div>
                    <div v-else> {{ user.name }} does not have any beats. </div>
                </div>
                <div v-else>
                    {{ user.name }} does not have any beats.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SearchBar from './../searchbar.vue'
    import PrimaryBeats from './../discover/primary-beats.vue'
    import SecondaryBeats from './../discover/secondary-beats.vue'
    import Latest from './../discover/new-beats.vue'
    import Licenses from './../discover/licenses.vue'
    import Trending from './../discover/trending-beats.vue'
    import Soundkits from './../discover/soundkits.vue'
    import Songs from './../discover/songs.vue'
    import BeatTapes from './../discover/beat-tapes.vue'
    import Services from './../discover/services.vue'
    import TopFiveBeats from './../discover/top-five-beats.vue'

    import Playlist from './../../classes/playlist';
    import Configure from './../../mixins/configure';
    import Discover from './../../mixins/discover';

	export default {
        props:['pageId'],
        beforeCreate() {
            this.$store.state.playlistManager.setPagePlaylist(new Playlist([], "discover"));
		},
        mounted () {
//          Function created by vue-waypoint
            //this.$setWaypointScrollElement(document.getElementById('app_body'))
            this.currentPageId = this.pageId
            this.$http.get(`${ab.apiUrl}/users/${this.user.id}/has/beats`)
            .then(response => this.userHasBeats = response.data.hasBeats)
            .catch(error => this.userHasBeats = false)
        },
        beforeDestroy () {
            this.$setWaypointScrollElement(window)
        },
        components: {
            SearchBar, PrimaryBeats ,Latest, Services, SecondaryBeats,Trending,Licenses,Soundkits , TopFiveBeats, Songs, BeatTapes
        },
        data() {
            return {
                currentPageId: null,
                userHasBeats: true
            }
        },
        mixins: [Configure, Discover],
        methods : {
        },
        computed: {
            appUrl () {
                return ab.appUrl
            },
            user () {
                return this.$store.state.user
            },
            loggedInUser () {
                return this.$store.state.loggedInUser
            },
            viewPortWidth() {
                return this.$store.state.viewPortWidth
            },
            page() {
                if (this.currentPageId) {
                    let page = this.config.getPageById(this.currentPageId)
                    this.$store.commit("currentPage", {page: page})

                    return page
                }
                return false
            },
            config() {
	            return this.$store.state.currentConfig
            },
            display(){
                if(this.page){
                    return this.page.new.display
                }

                return 'list';
            }
        },
        watch: {
            'pageId': {
                handler(val) {
                    this.currentPageId = val
                }
            },
            'page.featured': {
                handler (val) {
                    if (val === undefined) return

                    if (this.$store.state.discoverPageInitialLoad && (val.primary.show || val.secondary.show)) {
                        this.featuredRequest()
                    }
                }, deep: true
            },
            'page.new': {
                handler (val) {
                    if (val === undefined) return

                    if (this.$store.state.discoverPageInitialLoad && val.show) {
                        this.newBeatsRequest()
                    }
                }, deep: true
            },
            'page.trending': {
                handler (val) {
                    if (val === undefined) return

                    if (this.$store.state.discoverPageInitialLoad && val.show) {
                        this.trendingBeatsRequest()
                    }
                }, deep: true
            },
            'page.soundkits': {
                handler (val) {
                    if (val === undefined) return

                    if (this.$store.state.discoverPageInitialLoad && val.show) {
                        this.soundkitsRequest()
                    }
                },
                deep: true
            },
            'page.services': {
                handler (val) {
                    if (val === undefined) return

                    if (this.$store.state.discoverPageInitialLoad && val.show) {
                        this.servicesRequest()
                    }
                },
                deep: true
            },
            'page.songs': {
                handler (val) {
                    if (val === undefined) return

                    if (this.$store.state.discoverPageInitialLoad && val.show) {
                        this.songsRequest()
                    }
                },
                deep: true
            },
            '$store.state.currentConfig': {
                handler (val) {
                    this.currentPageId = val.pagesConfig.find((page) => page.type === 'discover').id
                    this.addDiscoverPlaylistOnce()
                    this.$forceUpdate()
                },
                immediate: true
            }
        }

	}
</script>
